import { gql } from "@apollo/client";

export const cancelBookings = gql`
  mutation cancelBookings($bookingIds: [ID]!) {
    cancelBookings(bookingIds: $bookingIds) {
      id
    }
  }
`;
